// src/components/BlogList.jsx
import React, { useState, useEffect } from 'react';
import BlogCard from './BlogCard';
import metadata from '../content/metadata.json';
import '../styles/BlogList.css';

const BlogList = () => {
  const [posts, setPosts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState('All');

  useEffect(() => {
    // Set all posts
    setPosts(metadata);
    
    // Extract unique categories
    const uniqueCategories = ['All', ...new Set(metadata.map(post => post.category))];
    setCategories(uniqueCategories);
  }, []);

  const filteredPosts = activeCategory === 'All' 
    ? posts 
    : posts.filter(post => post.category === activeCategory);

  return (
    <div className="blog-list-container">
      <div className="blog-list-header">
        <h1>Latest Articles</h1>
        <div className="blog-list-categories">
          {categories.map(category => (
            <button
              key={category}
              className={`category-button ${activeCategory === category ? 'active' : ''}`}
              onClick={() => setActiveCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>
      </div>
      <div className="blog-grid">
        {filteredPosts.map(post => (
          <div key={post.slug} className="blog-grid-item">
            <BlogCard post={post} />
          </div>
        ))}
      </div>
      {filteredPosts.length === 0 && (
        <div className="no-posts">
          <p>No articles found in this category.</p>
        </div>
      )}
    </div>
  );
};

export default BlogList;